import React, { useEffect, useState, } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Grid, Box, CircularProgress } from "@mui/material"
import { styled } from "@mui/material/styles";
import { useTheme } from '@mui/material/styles';

import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';

import LinePiece from "../../components/linepiece";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLine } from '../../store/features/line';

const StyledSelect = styled(Select)(({ theme }) => ({
  color: 'black',
  '& .MuiSelect-icon': {
    color: 'rgb(39,159,91)', // 修改箭头颜色
    top: 'calc(50% - 12px)', // 调整箭头垂直居中
  },
  '& .MuiInput-input': {
    padding: "2px 0px 2px 0px"
  }

}));

const StyledLabel = styled((props) => <InputLabel {...props} />)(
  ({ theme }) => ({
    color: 'black',
    zIndex: 9,
    pointerEvents: 'none',
    top: '8px',
    left: '5px',
    fontSize: '0.8rem'
  })
);

const WaterFall = () => {
  const { data } = useSelector((store) => store.line);
  const { loading } = useSelector((store) => store.line);

  const storageURL = process.env.REACT_APP_Stroage_URL;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  const keyword = queryParams.get('keyword');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchLine());
  }, []);

  return (
    loading ?
      <Grid sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
        <CircularProgress color='mgreen' />
      </Grid>
      :
      <Grid sx={{ padding: 0 }}>
        <ImageList sx={{marginTop:1}}
          variant="masonry" cols={2} gap={12}>
          {
            data && data.map((item, index) => (
              <ImageListItem key={index}>
                <LinePiece data={item}></LinePiece>
              </ImageListItem>
            ))
          }
        </ImageList>
        {
          data&&data.length == 0 &&
          <Box sx={{ color: '#888888', display: 'flex', justifyContent: 'center', marginTop: '1rem',textAlign:'center' }} >
            没有更多数据
          </Box>
        }
      </Grid>
  )
}


export default function YeTai() {

  const location = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // 平滑滚动
    });
    return () => {
      // map?.destroy();
    };

  }, []);

  const theme = useTheme();

  return (
    <Container className='text-mblack' sx={{ marginTop: '5rem' }}>

      <WaterFall></WaterFall>


    </Container >
  );
}